import { pageLinkHtml } from "../../elements/page-link/component.js";
import { validate } from "../../helpers/validate.js";
import { attributesPageLinkSchema } from "./attributes.js";
import { ScalarPageLinkVue } from "./component.js";
import { hydrate } from "./hydration.js";
const scalarPageLink = {
  name: "scalar-page-link",
  tagName: "scalar-page-link",
  tiptapName: "custom_page_link",
  attributeTransform: (_, attrs) => {
    const filepath = typeof attrs.filepath === "string" ? attrs.filepath : "";
    const normalizedFilepath = filepath.startsWith("/") ? filepath.substring(1) : filepath;
    return validate(attributesPageLinkSchema, {
      ...attrs,
      filepath: normalizedFilepath,
      title: typeof attrs.title === "string" ? attrs.title : void 0,
      description: typeof attrs.description === "string" ? attrs.description : void 0
    });
  },
  render: async (props) => {
    const transformed = scalarPageLink.attributeTransform("", props);
    return transformed ? pageLinkHtml(transformed) : "";
  },
  hydrate
};
export {
  ScalarPageLinkVue,
  scalarPageLink
};
//# sourceMappingURL=index.js.map
